var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#079D7B",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-9",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 2.666667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55476746,12 C8.58351552,12.8338666 7.3467334,13.3333333 6,13.3333333 C4.6532666,13.3333333 3.41648448,12.8338666 2.44523254,12 L9.55476746,12 Z M6,9.33333333 C7.11409165,9.33333333 8.10052707,9.22402107 8.70579646,9.20385485 C8.50802425,9.25501804 8.31324279,9.29809618 8.12274338,9.33350199 L11.3333333,9.33333333 C11.1751933,9.80803868 10.9623465,10.2553256 10.7028302,10.6666667 L10.7028302,10.6666667 L1.29716981,10.6666667 C1.03765349,10.2553256 0.824806705,9.80803868 0.666666667,9.33333333 L0.666666667,9.33333333 L3.83615975,9.33392188 C3.64432916,9.29638487 3.44843716,9.2511371 3.25016989,9.19801155 L3.26958647,9.20307803 C3.87251737,9.22101089 4.87067291,9.33333333 6,9.33333333 Z M6,2.66666667 C7.04107893,2.66666667 7.88504015,4.15905083 7.88504015,6 C7.88504015,6.29231778 7.86376124,6.57584713 7.82379306,6.84600879 L7.92527811,6.81426028 L7.92527811,6.81426028 L8.13628589,6.75495355 C9.91450624,6.27848084 11.5016608,6.43569269 11.6812948,7.10609604 C11.8436626,7.71206062 10.8005104,8.52989244 9.28531258,9.03337405 C9.0174485,8.23932488 7.64846755,8 6,8 C4.35015758,8 2.98026815,8.23972425 2.71363411,9.03436807 C1.21908738,8.53153544 0.194664036,7.72230362 0.355673329,7.12140875 C0.535307365,6.45100541 2.12246193,6.29379356 3.90068228,6.77026626 C3.99459993,6.79543142 4.0871722,6.82186093 4.17825273,6.84944979 C4.13650359,6.57936453 4.11495985,6.29413116 4.11495985,6 C4.11495985,4.15905083 4.95892107,2.66666667 6,2.66666667 Z",
    id: "Mask",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.666666667,3.33333333 C1.0348565,3.33333333 1.33333333,3.63181017 1.33333333,4 C1.33333333,4.36818983 1.0348565,4.66666667 0.666666667,4.66666667 C0.298476833,4.66666667 0,4.36818983 0,4 C0,3.63181017 0.298476833,3.33333333 0.666666667,3.33333333 Z M11.3333333,3.33333333 C11.7015232,3.33333333 12,3.63181017 12,4 C12,4.36818983 11.7015232,4.66666667 11.3333333,4.66666667 C10.9651435,4.66666667 10.6666667,4.36818983 10.6666667,4 C10.6666667,3.63181017 10.9651435,3.33333333 11.3333333,3.33333333 Z M9.33333333,1.33333333 C9.70152317,1.33333333 10,1.63181017 10,2 C10,2.36818983 9.70152317,2.66666667 9.33333333,2.66666667 C8.9651435,2.66666667 8.66666667,2.36818983 8.66666667,2 C8.66666667,1.63181017 8.9651435,1.33333333 9.33333333,1.33333333 Z M2.66666667,1.33333333 C3.0348565,1.33333333 3.33333333,1.63181017 3.33333333,2 C3.33333333,2.36818983 3.0348565,2.66666667 2.66666667,2.66666667 C2.29847683,2.66666667 2,2.36818983 2,2 C2,1.63181017 2.29847683,1.33333333 2.66666667,1.33333333 Z M6,0 C6.36818983,0 6.66666667,0.298476833 6.66666667,0.666666667 C6.66666667,1.0348565 6.36818983,1.33333333 6,1.33333333 C5.63181017,1.33333333 5.33333333,1.0348565 5.33333333,0.666666667 C5.33333333,0.298476833 5.63181017,0 6,0 Z",
    id: "Oval-184",
    fill: "#FCD117"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMo);
export default __webpack_public_path__ + "static/media/MO.fd4faf6fb6504057225ac5b2bbde7be0.svg";
export { ForwardRef as ReactComponent };